export default __webpack_public_path__ + "static/media/building.71544633.svg";